(function () {
  'use strict';

  function parseTags(raw) {
    if (!raw) return [];
    return raw
      .toLowerCase()
      .split('|')
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  function tagInList(tags, tag) {
    return tags.indexOf(tag) !== -1;
  }

  function initCollection(root) {
    if (!root || root.dataset.luxColInit) return;
    root.dataset.luxColInit = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-lux-col-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-lux-col-filter]'));
    var countEls = root.querySelectorAll('[data-lux-col-count]');
    var sortEls = root.querySelectorAll('[data-lux-col-sort]');
    var priceRange = root.querySelector('[data-lux-col-price-range]');
    var priceLabel = root.querySelector('[data-lux-col-price-label]');
    var sidebar = root.querySelector('[data-lux-col-sidebar]');
    var grid = root.querySelector('[data-lux-col-grid]');

    var activeChips = [];
    var maxPrice = priceRange ? parseInt(priceRange.value, 10) : Infinity;
    var emptyState = null;

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function cardMatchesSidebar(tags) {
      if (!sidebar) return true;

      var sections = sidebar.querySelectorAll('.lux-col-sidebar__section[data-lux-col-filter-group]');
      for (var i = 0; i < sections.length; i++) {
        var section = sections[i];
        var checked = Array.prototype.slice
          .call(section.querySelectorAll('.lux-col-sidebar__check:checked'))
          .map(function (el) {
            return el.value;
          });
        var activeSwatch = section.querySelector('[data-lux-col-swatch].is-active');
        var swatchTag = activeSwatch ? activeSwatch.getAttribute('data-lux-col-swatch') : null;

        if (!checked.length && !swatchTag) continue;

        var groupMatch = checked.some(function (tag) {
          return tagInList(tags, tag);
        });

        if (swatchTag && tagInList(tags, swatchTag)) {
          groupMatch = true;
        }

        if (!groupMatch) return false;
      }

      return true;
    }

    function cardMatches(card) {
      var tags = parseTags(card.getAttribute('data-tags'));
      var price = parseInt(card.getAttribute('data-price') || '0', 10);

      if (price > maxPrice) return false;

      if (activeChips.length) {
        var chipMatch = activeChips.some(function (tag) {
          return tagInList(tags, tag);
        });
        if (!chipMatch) return false;
      }

      return cardMatchesSidebar(tags);
    }

    function ensureEmptyState() {
      if (!grid) return null;
      if (!emptyState) {
        emptyState = document.createElement('p');
        emptyState.className = 'lux-col-empty lux-col-empty--filtered';
        emptyState.hidden = true;
        emptyState.textContent = 'No products match your filters. Try adjusting your selection.';
        grid.appendChild(emptyState);
      }
      return emptyState;
    }

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (card) {
        var show = cardMatches(card);
        card.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      countEls.forEach(function (countEl) {
        countEl.textContent = visible + ' product' + (visible === 1 ? '' : 's');
      });

      var empty = ensureEmptyState();
      if (empty) empty.hidden = visible > 0;
    }

    function countForTag(tag) {
      return cards.filter(function (card) {
        return tagInList(parseTags(card.getAttribute('data-tags')), tag);
      }).length;
    }

    function updateFilterAvailability() {
      chips.forEach(function (chip) {
        var filter = chip.getAttribute('data-lux-col-filter') || 'all';
        if (filter === 'all') return;
        var count = countForTag(filter);
        chip.classList.toggle('is-disabled', count === 0);
        chip.disabled = count === 0;
      });

      if (!sidebar) return;

      sidebar.querySelectorAll('[data-lux-col-sidebar-opt]').forEach(function (opt) {
        var tag = opt.getAttribute('data-lux-col-sidebar-opt');
        var countNode = opt.querySelector('[data-lux-col-opt-count]');
        if (!tag) return;
        var count = countForTag(tag);
        if (countNode) countNode.textContent = count > 0 ? count : '';
        opt.classList.toggle('is-disabled', count === 0);
        var input = opt.querySelector('.lux-col-sidebar__check');
        if (input && count === 0) {
          input.checked = false;
          opt.classList.remove('is-checked');
        }
      });

      sidebar.querySelectorAll('[data-lux-col-swatch]').forEach(function (swatch) {
        var tag = swatch.getAttribute('data-lux-col-swatch');
        if (!tag) return;
        var count = countForTag(tag);
        swatch.classList.toggle('is-disabled', count === 0);
        if (count === 0) swatch.classList.remove('is-active');
      });
    }

    function syncSidebarFromChips() {
      if (!sidebar || !activeChips.length) return;
      activeChips.forEach(function (tag) {
        var input = sidebar.querySelector('.lux-col-sidebar__check[value="' + tag + '"]');
        if (input && !input.disabled) {
          input.checked = true;
          var label = input.closest('.lux-col-sidebar__opt');
          if (label) label.classList.add('is-checked');
        }
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-lux-col-filter') || 'all';
        if (chip.disabled) return;

        if (filter === 'all') {
          chips.forEach(function (c) {
            c.classList.remove('is-active');
          });
          chip.classList.add('is-active');
          activeChips = [];
          if (sidebar) {
            sidebar.querySelectorAll('.lux-col-sidebar__check').forEach(function (input) {
              input.checked = false;
              var label = input.closest('.lux-col-sidebar__opt');
              if (label) label.classList.remove('is-checked');
            });
            sidebar.querySelectorAll('[data-lux-col-swatch]').forEach(function (swatch) {
              swatch.classList.remove('is-active');
            });
          }
        } else {
          var allChip = chips.find(function (c) {
            return (c.getAttribute('data-lux-col-filter') || 'all') === 'all';
          });
          if (allChip) allChip.classList.remove('is-active');
          chip.classList.toggle('is-active');
          activeChips = chips
            .filter(function (c) {
              var val = c.getAttribute('data-lux-col-filter') || 'all';
              return val !== 'all' && c.classList.contains('is-active');
            })
            .map(function (c) {
              return c.getAttribute('data-lux-col-filter');
            });

          if (!activeChips.length && allChip) {
            allChip.classList.add('is-active');
          } else {
            syncSidebarFromChips();
          }
        }

        applyFilters();
      });
    });

    if (sidebar) {
      sidebar.querySelectorAll('.lux-col-sidebar__check').forEach(function (input) {
        input.addEventListener('change', function () {
          var label = input.closest('.lux-col-sidebar__opt');
          if (label) label.classList.toggle('is-checked', input.checked);

          var allChip = chips.find(function (c) {
            return (c.getAttribute('data-lux-col-filter') || 'all') === 'all';
          });
          if (allChip) allChip.classList.remove('is-active');

          activeChips = [];
          chips.forEach(function (chip) {
            if ((chip.getAttribute('data-lux-col-filter') || 'all') === 'all') return;
            var tag = chip.getAttribute('data-lux-col-filter');
            var matched = sidebar.querySelector('.lux-col-sidebar__check[value="' + tag + '"]:checked');
            chip.classList.toggle('is-active', !!matched);
            if (matched) activeChips.push(tag);
          });

          if (!activeChips.length && allChip) {
            allChip.classList.add('is-active');
          }

          applyFilters();
        });
      });

      sidebar.querySelectorAll('[data-lux-col-swatch]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.classList.contains('is-disabled')) return;
          var tag = swatch.getAttribute('data-lux-col-swatch');
          var groupId = swatch.getAttribute('data-lux-col-filter-group');
          var groupSwatches = groupId
            ? sidebar.querySelectorAll('[data-lux-col-filter-group="' + groupId + '"] [data-lux-col-swatch]')
            : sidebar.querySelectorAll('[data-lux-col-swatch]');

          if (swatch.classList.contains('is-active')) {
            swatch.classList.remove('is-active');
          } else {
            Array.prototype.forEach.call(groupSwatches, function (s) {
              s.classList.remove('is-active');
            });
            swatch.classList.add('is-active');
          }

          applyFilters();
        });
      });
    }

    if (priceRange) {
      var syncRange = function () {
        maxPrice = parseInt(priceRange.value, 10);
        if (priceLabel) {
          priceLabel.textContent = 'Up to ' + formatMoney(maxPrice);
        }
        var min = parseInt(priceRange.min, 10);
        var max = parseInt(priceRange.max, 10);
        var pct = ((maxPrice - min) / (max - min)) * 100;
        priceRange.style.background =
          'linear-gradient(to right, #2D5A4F 0%, #2D5A4F ' + pct + '%, rgba(0,0,0,0.13) ' + pct + '%)';
        applyFilters();
      };
      priceRange.addEventListener('input', syncRange);
      syncRange();
    }

    sortEls.forEach(function (sortEl) {
      sortEl.addEventListener('change', function () {
        if (sortEl.value) window.location.href = sortEl.value;
      });
    });

    var filterOpenBtn = root.querySelector('[data-lux-col-filter-open]');
    var filterCloseEls = root.querySelectorAll('[data-lux-col-filter-close]');
    var filterBackdrop = root.querySelector('.lux-col-filter-backdrop');

    function setFilterDrawer(open) {
      root.classList.toggle('lux-collection-page--filters-open', open);
      if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (filterBackdrop) filterBackdrop.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }

    if (filterOpenBtn && sidebar) {
      filterOpenBtn.addEventListener('click', function () {
        setFilterDrawer(!root.classList.contains('lux-collection-page--filters-open'));
      });
    }

    filterCloseEls.forEach(function (el) {
      el.addEventListener('click', function () {
        setFilterDrawer(false);
      });
    });

    root.querySelectorAll('.lux-col-card__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.stopPropagation();
      });
    });

    updateFilterAvailability();
    applyFilters();
  }

  function boot() {
    document.querySelectorAll('[data-lux-collection]').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-lux-collection]');
    if (root) initCollection(root);
  });
})();
